import { Injectable } from '@angular/core';

import { ItemView, ItemViewProviderDirective } from '@ntap/core';

/**
 * Provide this service in the component where you want to remember
 * the parent item for child components
 * deeper in the hierarchy to use.
 *
 */

@Injectable()
export class ParentItemProviderService {
  public parentItem$;

  constructor(protected itemViewProvider: ItemViewProviderDirective<ItemView>) {
    this.parentItem$ = this.itemViewProvider.item$;
  }
}
